/** @jsxImportSource @emotion/react */

import {
  FOCUSED_TASK_CARD_DESCRIPTION,
  FOCUSED_TASK_CARD_DESCRIPTION_EMPTY,
  FOCUSED_TASK_CARD_LABEL,
  FOCUSED_TASK_CARD_SECTION,
} from './focusedTaskCardStyles';

// Single source of truth for this component's own user-facing copy —
// referenced by tests instead of duplicating the literal string.
export const DESCRIPTION_LABEL = 'Task description';
export const DESCRIPTION_EMPTY_TEXT = 'No description';

/**
 * The task's description, always in full — never behind a second click within the
 * "Task Details" fold that holds it (see FocusedTaskFields). A description you have
 * to ask for is a description that goes unread; the fold itself opens by default
 * exactly when there's reading to do (draft and review) and only tucks away once the
 * contractor is settled and the description has become reference material.
 * Always renders its label and a value, so the description column lines up with the
 * contractor column beside it even when there's nothing to show yet.
 */
export const TaskDescription = ({
  description,
}: {
  description?: string;
}) => (
  <div css={FOCUSED_TASK_CARD_SECTION}>
    <span css={FOCUSED_TASK_CARD_LABEL}>{DESCRIPTION_LABEL}</span>
    {description
      ? <div css={FOCUSED_TASK_CARD_DESCRIPTION}>{description}</div>
      : <span css={FOCUSED_TASK_CARD_DESCRIPTION_EMPTY}>{DESCRIPTION_EMPTY_TEXT}</span>}
  </div>
);
